import React from "react";
import { Box } from "@mui/material";
import ContactUsHero from "./components/ContactUsHero";
import ContactDetailsMap from "./components/ContactDetailsMap";
// import ContactFAQ from "./components/ContactFAQ";
import "./contact-us-page-new.scss";

export default function ContactUsPageNew() {
  return (
    <Box className="contact-us">
      {/* Section 1 : Contact us form */}
      <Box className="contact-us__hero">
        <ContactUsHero />
      </Box>

      {/* Section 2: contact info + map */}
      <Box className="contact-us__details-map">
        <ContactDetailsMap />
      </Box>

      {/* Section 3: FAQ Accordions */}
      {/* <Box className="contact-us__faq">
        <ContactFAQ />
      </Box> */}
    </Box>
  );
}
